export * from './localizationHelpers';
import {
  fields
} from './localizationHelpers';
import {
  untouch,
  touch
} from 'redux-form';

export const LOAD_CUSTOMER = 'mp/moving/LOAD_CUSTOMER';
export const SET_CUSTOMER = 'mp/moving/SET_CUSTOMER';
export const MOVE_CUSTOMER = 'mp/moving/MOVE_CUSTOMER';
export const GET_SUGGESTIONS = 'mp/moving/GET_SUGGESTIONS';
export const SELECT_SUGGESTION = 'mp/moving/SELECT_SUGGESTION';
export const DL_PAGE_LOADED = 'mp/movers/localization/DL_PAGE_LOADED';

export const loadCustomer = () => {
  return {
    type: LOAD_CUSTOMER
  };
};
export const moveCustomer = () => {
  return {
    type: MOVE_CUSTOMER
  };
};
export const getSuggestions = (search) => {
  return {
    type: GET_SUGGESTIONS,
    payload: {
      search
    }
  };
};

export const selectSuggestion = suggestion => {
  return {
    type: SELECT_SUGGESTION,
    payload: {
      suggestion
    }
  };
};

export const touchFields = () => {
  return (dispatch) => {
    dispatch(untouch('movers', ...fields));
    dispatch(touch('movers', ...fields));
  };
};



/** WEBPACK FOOTER **
 ** ./client/redux/modules/pages/Movers/localization/localization.js
 **/